import { render, staticRenderFns } from "./SettingsSecurityCoursePrivacy.vue?vue&type=template&id=0e54e32a&scoped=true"
import script from "./SettingsSecurityCoursePrivacy.vue?vue&type=script&lang=js"
export * from "./SettingsSecurityCoursePrivacy.vue?vue&type=script&lang=js"
import style0 from "./SettingsSecurityCoursePrivacy.vue?vue&type=style&index=0&id=0e54e32a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e54e32a",
  null
  
)

export default component.exports